import { createApi } from "./client";
import type { ConfirmReservationResponse } from "../types/models";

export function confirmReservationFromLink(apiBase: string, companySlug: string, token: string) {
    const api = createApi(apiBase);
    const url = `/api/companies/${companySlug}/reservations/confirm?token=${encodeURIComponent(token)}`;
    return api<ConfirmReservationResponse>(url, { method: "GET" });
}
